import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Gallery } from "../components/Gallery";
import { Reviews } from "../components/Reviews";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Gallery />
        <Reviews />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
